import { render, staticRenderFns } from "./Specified.vue?vue&type=template&id=376c41e4"
import script from "./Specified.js?vue&type=script&lang=js&external"
export * from "./Specified.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports